import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-533bc338")

_pushScopeId("data-v-533bc338")
const _hoisted_1 = { class: "flex flex-col justify-between h-full pb-4" }
const _hoisted_2 = { class: "flex flex-row justify-around px-6" }
const _hoisted_3 = { class: "flex items-center text-black-lp-300" }
const _hoisted_4 = { class: "text-12px text-gray-lp-800 font-medium capitalize" }
const _hoisted_5 = { class: "flex items-center text-black-lp-300" }
const _hoisted_6 = { class: "text-12px text-gray-lp-800 font-medium capitalize" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DonutChart = _resolveComponent("DonutChart")!
  const _component_bullet_point = _resolveComponent("bullet-point")!
  const _component_CardDashboardClient = _resolveComponent("CardDashboardClient")!

  return (_openBlock(), _createBlock(_component_CardDashboardClient, {
    loading: _ctx.isLoading,
    title: _ctx.$t('dashboard.summary')
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DonutChart, {
          chartSeries: _ctx.chartData,
          chartColor: _ctx.chartColor,
          isShowTotal: "",
          chartTitle: _ctx.$t('dashboard.onTime'),
          showPercentage: "",
          class: _ctx.ableToViewDetail ? 'container-chart' : '',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickDetail('performance-summary')))
        }, null, 8, ["chartSeries", "chartColor", "chartTitle", "class"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: ["px-4 py-2 w-1/2 rounded", _ctx.ableToViewDetail ? 'section-legend cursor-pointer ' : ''],
            onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHover('onTime'))),
            onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onLeaveHover && _ctx.onLeaveHover(...args))),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClickDetail('performance-onTime')))
          }, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_bullet_point, {
                style: {"color":"#7ACB90"},
                class: "w-2 mr-1"
              }),
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("dashboard.onTime")), 1)
            ]),
            _createVNode("div", {
              style: _ctx.styleOnTimePerformance,
              class: "text-20px font-semibold"
            }, _toDisplayString(_ctx.formattedNumber(_ctx.dataPerformance.onTime)) + " " + _toDisplayString(_ctx.$t("dashboard.resi")), 5)
          ], 34),
          _createVNode("div", {
            class: ["px-4 py-2 w-1/2", _ctx.ableToViewDetail ? 'section-legend cursor-pointer ' : ''],
            onMouseover: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onHover('late'))),
            onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onLeaveHover && _ctx.onLeaveHover(...args))),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClickDetail('performance-late')))
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_bullet_point, {
                style: {"color":"#F05C72"},
                class: "w-2 mr-1"
              }),
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.late")), 1)
            ]),
            _createVNode("div", {
              style: _ctx.styleLatePerformance,
              class: "text-20px font-semibold"
            }, _toDisplayString(_ctx.formattedNumber(_ctx.dataPerformance.late)) + " " + _toDisplayString(_ctx.$t("dashboard.resi")), 5)
          ], 34)
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "title"]))
})